export default __webpack_public_path__ + "static/media/churn-sad.5ba76935.svg";